import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { FamilienStand, Tarifbereich } from '@ps20/bff-models';
import {
  App,
  determineAssekuranztarifFromTarifbereich,
  RsVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { convertDateFormatFromShortIsoToLocalState } from '@ps20-frontend/utils';
import { RsVermieterActions } from '../rs-vermietung-actions.service';

export interface Versicherungsnehmer {
  geburtsdatum: string;
  familienstand: FamilienStand;
  isAssekuranztarif: boolean;
  tarifbereich?: Tarifbereich;
  juristisch?: boolean;
}

export const versicherungsnehmerReducer = function (
  sectionState: Versicherungsnehmer = null,
  action: AnyAction,
): Versicherungsnehmer {
  switch (action.type) {
    case RsVermieterActions.FAMILIENSTAND_CHANGED: {
      return {
        ...sectionState,
        familienstand: action.payload.familienstand,
      };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const versicherungsnehmer: Versicherungsnehmer = action.payload.versicherungsnehmer;
      const juristisch = versicherungsnehmer.juristisch;
      if (versicherungsnehmer?.geburtsdatum) {
        const dateSplitted = versicherungsnehmer.geburtsdatum.split('-');
        const dateAsString = `${dateSplitted[2]}.${dateSplitted[1]}.${dateSplitted[0]}`;
        return {
          ...sectionState,
          juristisch,
          geburtsdatum: dateAsString,
        };
      } else {
        return { ...sectionState, juristisch };
      }
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD:
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA: {
      return {
        ...sectionState,
        isAssekuranztarif: action.payload,
      };
    }
    case GlobalActions.TARIFBEREICH_CHANGED: {
      return {
        ...sectionState,
        tarifbereich: action.payload,
        isAssekuranztarif: determineAssekuranztarifFromTarifbereich(action.payload),
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: RsVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.RS_VERMIETUNG) {
        return {
          ...sectionState,
          geburtsdatum: actionPayload.geburtsdatumVn
            ? convertDateFormatFromShortIsoToLocalState(actionPayload.geburtsdatumVn)
            : sectionState.geburtsdatum,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
